import React, { useState, memo } from "react";
import { Map, TileLayer } from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";
import MapCache from "../MapCache";
import LayerControlMap from "../LayerControlMap";
import "./style.scss";
import mapHelpers from '../../utils/mapHelpers';

const MAP_ZOOM = 15;

const CarMap = memo(({ geojson, id, layers, carLayers, ...props }) => {
  const isMultiPolygon = geojson.type === 'MultiPolygon';

  const onlyXY = mapHelpers.getOnlyXY(geojson.coordinates, { isMultiPolygon });

  const [bounds] = useState(mapHelpers.reverseCoordinates(onlyXY, { isMultiPolygon }));

  return (
    <>
      <Map
        fullscreenControl
        zoom={MAP_ZOOM}
        bounds={bounds}
        maxBounds={bounds}
        {...props}
      >
        <TileLayer
          url="http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
          minZoom="10"
          subdomains={["mt0", "mt1", "mt2", "mt3"]}
        />

        <LayerControlMap key={id} layers={layers} />
        <LayerControlMap key={id} layers={carLayers} />

        <MapCache />
      </Map>
    </>
  );
});

export default CarMap;
